export const GTM_IDS = process.env.NEXT_PUBLIC_GTM_IDS
  ? process.env.NEXT_PUBLIC_GTM_IDS.split(',')
  : []

interface CustomWindow extends Window {
  dataLayer: Array<any>
}

export const pageView = (url: string) => {
  const customWindow = window as unknown as CustomWindow
  GTM_IDS.forEach((id) => {
    customWindow.dataLayer.push({
      event: 'pageView',
      page: url,
      'gtm.containerId': id,
    })
  })
}
